import { compose } from 'recompose';

import UserEdit from './UserEdit';

const enhance = compose();

export default enhance(UserEdit);
